import React from 'react';

export default function Meet() {
  return (
    <div>Meet</div>
  );
}
